export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-thumbnail-d8dc13d1c66b9f0d1eac4e93c469b04c.png";